<template>
    <AnagraficaCrud titolo="Uf legno (metodo semplificato 10077-1)" endpoint="uf-legno" nuovo-label="Nuova riga"
        :colonne="colonne" :campi="campi" :puo-scrivere="puoScrivere"
        colonne-import="Spessore, UfTENERO, UfDURO" />
</template>

<script>
import AnagraficaCrud from "@/components/AnagraficaCrud.vue";

export default {
    name: "UfLegnoPage",
    components: { AnagraficaCrud },

    data() {
        return {
            colonne: [
                { title: "Spessore medio telaio (mm)", key: "spessore" },
                { title: "Uf tenero (W/m²K)", key: "ufTenero" },
                { title: "Uf duro (W/m²K)", key: "ufDuro" },
            ],
            campi: [
                { key: "spessore", label: "Spessore medio telaio (mm)", tipo: "number", step: 1, required: true, cols: 12 },
                { key: "ufTenero", label: "Uf tenero (W/m²K)", tipo: "number" },
                { key: "ufDuro", label: "Uf duro (W/m²K)", tipo: "number" },
            ],
        };
    },

    computed: {
        puoScrivere() {
            const ruolo = this.$store.getters["user/getRole"];
            return ruolo === "Admin" || ruolo === "SuperAdmin";
        },
    },
};
</script>
